import React, { Component } from "react";
import Card from "./Card";
import Header from "../../Components/MainLayout/Header";
import Axios from "axios";
import { connect } from "react-redux";
import Skeleton from "react-loading-skeleton";
import { withRouter } from "react-router-dom";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Payments extends Component {
  state = { exam: [], loading: false, fakeData: [1, 2, 3, 4] };

  componentDidMount() {
    this.fetchfee({
      session: this.props.user.student_info.session.id,
      for_class: this.props.user.student_class.id,
      exam_system_type: this.props.match.params.Id,
    });
  }

  fetchfee = (params = {}) => {
    this.setState({ loading: true });
    Axios.get(`/api/exams`, {
      params: { ...params },
    })
      .then((res) => {
        this.setState({ exam: res.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <Header to="/home" title="Exam Schedule" />
        {this.state.loading ? (
          <div className="container pt-3">
            {this.state.fakeData?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="border p-3 shadow-sm rounded-lg mb-3"
                >
                  <Skeleton width={100} />
                  <Skeleton count={2} />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="container pt-3 pb-5">
            {this.state.exam.length === 0 ? (
              <p className="th-12 text-center py-5">No Exam for Now.</p>
            ) : (
              this.state.exam?.map((item, index) => {
                return (
                  <div key={index}>
                    <Card
                      title={item.exam_system_type?.exam_type.exam_type}
                      date={item.exam_system_subject?.subject.subject}
                      detail={item}
                    />
                  </div>
                );
              })
            )}
            <div className="py-3"></div>
          </div>
        )}
      </div>
    );
  }
}
export default withRouter(connect(mapStateToProps)(Payments));
